import { Component } from "@angular/core";

import { ICellRendererParams } from 'ag-grid-community';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { AgGridColumnDef } from "./ag-grid.component";

interface AgGridCustomCellRendererParams extends ICellRendererParams {
  columnDef: AgGridColumnDef;
}

@Component({
  selector: 'datex-ag-grid-cell-renderer',
  templateUrl: './ag-grid-cell-renderer.component.html',
  standalone: false
})
export class AgGridCustomCellRenderer implements ICellRendererAngularComp {
  row: any;
  columnDef: AgGridColumnDef;

  agInit(params: AgGridCustomCellRendererParams): void {
    this.row = params.data;
    this.columnDef = params.columnDef;
  }

  refresh(params: AgGridCustomCellRendererParams): boolean {
    return false;
  }
}